import { supabase } from "@/lib/supabase/client";
import type { AuthConsentRecord } from "./authConsents";

type FunctionsInvoke = (
  name: string,
  options: {
    body?: Record<string, unknown>;
  },
) => Promise<{
  data: {
    error?: string;
    recorded?: number;
  } | null;
  error: {
    message?: string;
  } | null;
}>;

function readErrorMessage(
  error: { message?: string } | null,
  data: { error?: string } | null,
  fallbackMessage: string,
) {
  if (error?.message) {
    return error.message;
  }

  if (typeof data?.error === "string" && data.error) {
    return data.error;
  }

  return fallbackMessage;
}

export async function recordAuthConsents(params: {
  consents: AuthConsentRecord[];
  source?: string;
  invoke?: FunctionsInvoke;
}) {
  const invoke = params.invoke ?? ((name, options) => supabase.functions.invoke(name, options));
  const { data, error } = await invoke("record_auth_consents", {
    body: {
      consents: params.consents,
      source: params.source ?? "login",
    },
  });

  if (error || data?.error) {
    throw new Error(readErrorMessage(error, data, "필수 약관 동의를 저장하지 못했습니다."));
  }

  return data?.recorded ?? 0;
}
